import React from 'react';
import { withSearch } from '@elastic/react-search-ui';
import { Button } from 'reactstrap';
import classNames from 'classnames';
var blockClass = 'clear-filters';
var ClearFilters = function ClearFilters(_ref) {
  var filters = _ref.filters,
    clearFilters = _ref.clearFilters,
    removeFilter = _ref.removeFilter,
    buttonColor = _ref.buttonColor,
    ignoreFilters = _ref.ignoreFilters,
    className = _ref.className;
  if (filters) {
    var classes = classNames(blockClass, className);
    filters = filters.filter(function (filter) {
      return ignoreFilters.indexOf(filter.field) < 0;
    });
    if (filters.length > 0) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, filters.map(function (filter, i) {
        return /*#__PURE__*/React.createElement(Button, {
          size: "sm",
          color: buttonColor,
          className: blockClass + "__btn",
          key: i,
          onClick: function onClick() {
            return removeFilter(filter.field);
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: blockClass + "__field text-capitalize"
        }, filter.field.replace(/-|_/g, ' '), ":", ' '), filter.values.map(function (value, i) {
          return /*#__PURE__*/React.createElement("span", {
            className: blockClass + "__value",
            key: i
          }, i !== 0 ? ', ' : '', value);
        }));
      }), /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        className: blockClass + "__btn " + blockClass + "__btn--all",
        color: buttonColor,
        onClick: function onClick() {
          return clearFilters();
        }
      }, "Clear All Filters"));
    }
  }
  return null;
};
export default withSearch(function (_ref2) {
  var filters = _ref2.filters,
    clearFilters = _ref2.clearFilters,
    removeFilter = _ref2.removeFilter;
  return {
    filters: filters,
    clearFilters: clearFilters,
    removeFilter: removeFilter
  };
})(ClearFilters);
ClearFilters.defaultProps = {
  buttonColor: 'primary'
};